import type { ClientLegalDocumentId } from '../constants/clientLegalContent';
import {
  ClientLegalDocumentSubsections,
  type ClientLegalOpenState,
} from './ClientLegalDocumentSubsections';

export const CLIENT_LEGAL_DOCUMENT_IDS: ClientLegalDocumentId[] = [
  'termsOfUse',
  'privacyPolicy',
  'accessibilityStatement',
];

export type ClientLegalAgreementState = ClientLegalOpenState;

export function createEmptyClientLegalAgreementState(): ClientLegalAgreementState {
  return {
    termsOfUse: false,
    privacyPolicy: false,
    accessibilityStatement: false,
  };
}

export function isClientLegalAgreementComplete(agreed: ClientLegalAgreementState): boolean {
  return CLIENT_LEGAL_DOCUMENT_IDS.every((documentId) => agreed[documentId]);
}

type PlatformLegalDocumentsAcceptSectionProps = {
  idPrefix: string;
  open: ClientLegalAgreementState;
  agreed: ClientLegalAgreementState;
  theme?: 'dark' | 'light';
  disabled?: boolean;
  onToggleOpen: (documentId: ClientLegalDocumentId) => void;
  onAgreedChange: (documentId: ClientLegalDocumentId, agreed: boolean) => void;
};

export function PlatformLegalDocumentsAcceptSection({
  idPrefix,
  open,
  agreed,
  theme = 'light',
  disabled = false,
  onToggleOpen,
  onAgreedChange,
}: PlatformLegalDocumentsAcceptSectionProps) {
  return (
    <ClientLegalDocumentSubsections
      idPrefix={idPrefix}
      open={open}
      agreed={agreed}
      theme={theme}
      disabled={disabled}
      showGroupHeading
      showAgreeCheckboxes
      onToggleOpen={onToggleOpen}
      onAgreedChange={onAgreedChange}
    />
  );
}
